import { defineComponent, reactive, toRefs, onMounted, ref, computed } from 'vue';
import { Table, Empty, Tabs, TabPane } from 'ant-design-vue/es';
import dayjs from 'dayjs';
export default defineComponent({
  components: {
    Empty,
    'a-tab-pane': TabPane,
    'a-tabs': Tabs,
    'a-table': Table
  },
  setup() {
    const activeKey = ref('1');
    const columns = [{
      title: '姓名',
      width: 160,
      dataIndex: 'name',
      key: 'name'
    }, {
      title: '手机号',
      dataIndex: 'phone',
      width: 120,
      key: 'phone'
    }, {
      title: '地区',
      width: 150,
      dataIndex: 'area',
      key: 'area'
    }, {
      title: '投诉内容',
      width: 150,
      dataIndex: 'complaint',
      key: 'complaint'
    }, {
      title: '投诉时间',
      width: 150,
      dataIndex: 'complaintTime',
      key: 'complaintTime'
    }, {
      title: '反馈结果',
      width: 200,
      dataIndex: 'feedbackResult',
      key: 'feedbackResult'
    }, {
      title: '处理结果',
      key: 'resultRate',
      width: 180,
      dataIndex: 'resultRate'
    }];
    const shipperData = [{
      name: '榆林货达盛世物流有限公司',
      phone: '18992273654',
      area: '陕西省',
      complaint: '登录不了系统，咋回事',
      complaintTime: '2026-03-01',
      feedbackResult: '异地登录需要短信验证，已沟通解决',
      resultRate: '投诉满意率：95%',
      result: '评价结果：96'
    }
    // {
    //   name: '内蒙古建龙商贸有限公司',
    //   phone: '13674812050',
    //   area: '内藏古自治区',
    //   complaint:'站点不对，修改不了！！！',
    //   complaintTime:'2026-02-16',
    //   feedbackResult:'已电话沟通解决，操作问题，感谢配合',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：99',
    // },
    // {
    //   name: '陕西延长石油精原煤化工有限公司',
    //   phone: '15596535858',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：91',
    // },
    // {
    //   name: '陕西巨匠文化建材科技有限公司',
    //   phone: '18091259058',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：93',
    // },
    // {
    //   name: '陕西鸿发鑫泰能源发展有限公司',
    //   phone: '15129329605',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：97',
    // },
    // {
    //   name: '高平市鑫鼎物流有限公司',
    //   phone: '13283568856',
    //   area: '山西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：93',
    // },
    // {
    //   name: '榆林市博林煤业有限公司',
    //   phone: '18091992022',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：98',
    // },
    // {
    //   name: '府谷县伙盘沟煤矿洗选煤有限公司',
    //   phone: '15110572038',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：98%',
    //   result: '评价结果：94',
    // },
    // {
    //   name: '山西建龙实业有限公司',
    //   phone: '18406466661',
    //   area: '山西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：91',
    // },
    // {
    //   name: '榆林长河伟业商贸有限公司',
    //   phone: '15399286288',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：95%',
    //   result: '评价结果：92',
    // },
    // {
    //   name: '五寨县浩泰煤炭运销有限公司',
    //   phone: '18234130541',
    //   area: '山西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：98',
    // },
    // {
    //   name: '内蒙古共裕商贸有限公司',
    //   phone: '13835972619',
    //   area: '内蒙古自治区',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：96',
    // },
    // {
    //   name: '延安萌达煤炭运销有限责任公司',
    //   phone: '18098010826',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：92',
    // },
    // {
    //   name: '延安海庆工贸有限责任公司',
    //   phone: '18098010826',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：97%',
    //   result: '评价结果：95',
    // },
    // {
    //   name: '陕西省纳凯实业有限公司',
    //   phone: '13239278777',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：91',
    // },
    // {
    //   name: '榆林市云化绿能有限公司',
    //   phone: '15319650589',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：96',
    // },
    // {
    //   name: '榆林市榆阳区华泰汇能洗选煤有限公司',
    //   phone: '18691260827',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：95',
    // },
    // {
    //   name: '五寨默丰贸易有限公司',
    //   phone: '18735069856',
    //   area: '山西省',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：94',
    // },
    // {
    //   name: '鄂尔多斯市国源矿业开发有限责任公司',
    //   phone: '15149638181',
    //   area: '内蒙古自治区',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：91',
    // },
    // {
    //   name: '陕西美乐嘉和实业有限公司',
    //   phone: '18091388332',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：90',
    // },
    ];

    const driverData = [{
      name: '马强',
      phone: '15947479556',
      area: '陕西省',
      complaint: '接单一直接不了',
      complaintTime: '2026-03-17',
      feedbackResult: '资质认证未通过，已协助司机重新传最新证件认证过了，已接单',
      resultRate: '投诉满意率：92%',
      result: '评价结果：99',
      resultStop: '暂停服务：2日'
    }
    // {
    //   name: '孙飞',
    //   phone: '15149866591',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：95',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '郑玉伟',
    //   phone: '13932573681',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：95%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：4日',
    // },
    // {
    //   name: '王军',
    //   phone: '15247768002',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：95',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '王文亮',
    //   phone: '15903434971',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '崔存明',
    //   phone: '15924577212',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：90',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '吴宝军',
    //   phone: '18220479167',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：6日',
    // },
    // {
    //   name: '曹朋飞',
    //   phone: '17333928805',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：91',
    //   resultStop: '暂停服务：4日',
    // },
    // {
    //   name: '杜海林',
    //   phone: '15991987662',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：98%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '田西',
    //   phone: '18729093353',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：96',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '薛洪涛',
    //   phone: '18235920591',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：97%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '弓文亮',
    //   phone: '15034750707',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '屈国涛',
    //   phone: '13992916215',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：98%',
    //   result: '评价结果：96',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '杨飞',
    //   phone: '13654773855',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：96',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '苏海涛',
    //   phone: '15633562486',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：4日',
    // },
    // {
    //   name: '周卫亮',
    //   phone: '15831979960',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：97',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '高学军',
    //   phone: '13947778776',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '周宏福',
    //   phone: '18095572567',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：98%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '王世雄',
    //   phone: '13835259443',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：95',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '王军鹏',
    //   phone: '13468828343',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：97%',
    //   result: '评价结果：91',
    //   resultStop: '暂停服务：8日',
    // },
    // {
    //   name: '赵士忠',
    //   phone: '13834639513',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '边新勇',
    //   phone: '18409324416',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：97%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：4日',
    // },
    // {
    //   name: '武杰',
    //   phone: '13363987387',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '梁艮保',
    //   phone: '13947371615',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '陈红平',
    //   phone: '15374806898',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '常伟',
    //   phone: '18091252505',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：97',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '张丁云',
    //   phone: '13593101977',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：98',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '王英',
    //   phone: '13847136517',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：98%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '王露',
    //   phone: '15891327345',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：91',
    //   resultStop: '暂停服务：6日',
    // },
    // {
    //   name: '李清江',
    //   phone: '15033663000',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '任亮',
    //   phone: '14794899777',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：95%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '李宏斌',
    //   phone: '18735227736',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：97%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '孙存良',
    //   phone: '13474893876',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '任成军',
    //   phone: '18191594555',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '王建',
    //   phone: '15309120250',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '赵四全',
    //   phone: '15947222084',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '王宪闯',
    //   phone: '13030720060',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：97',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '张占兴',
    //   phone: '13930971303',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：5日',
    // },
    // {
    //   name: '陈宝灵',
    //   phone: '13994411276',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '蒋运权',
    //   phone: '13889757489',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：7日',
    // },
    // {
    //   name: '戚世鹤',
    //   phone: '17304380304',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '马辽辽',
    //   phone: '15319528755',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：96%',
    //   result: '评价结果：95',
    //   resultStop: '暂停服务：4日',
    // },
    // {
    //   name: '杜杰',
    //   phone: '13947744058',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：99%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：6日',
    // },
    // {
    //   name: '唐飞飞',
    //   phone: '18992518826',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：93%',
    //   result: '评价结果：92',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '刘神保',
    //   phone: '13593547199',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：91',
    //   resultStop: '暂停服务：6日',
    // },
    // {
    //   name: '白振军',
    //   phone: '15754729057',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：91%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '庞大兴',
    //   phone: '13934869881',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：94%',
    //   result: '评价结果：99',
    //   resultStop: '暂停服务：2日',
    // },
    // {
    //   name: '高玉峰',
    //   phone: '13753887007',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：92%',
    //   result: '评价结果：93',
    //   resultStop: '暂停服务：3日',
    // },
    // {
    //   name: '袁江',
    //   phone: '13754920004',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：90%',
    //   result: '评价结果：94',
    //   resultStop: '暂停服务：1日',
    // },
    // {
    //   name: '贺埃存',
    //   phone: '15147777918',
    //   area: '陕西省',
    //   resultRate: '投诉满意率：95%',
    //   result: '评价结果：90',
    //   resultStop: '暂停服务：2日',
    // },
    ];

    const phoneFormat = val => {
      return `${val.substring(0, 3)}****${val.substring(7, 11)}`;
    };
    const nameFormat = val => {
      return `${val.substring(0, 1)}*${val.substring(2, 10)}`;
    };
    const shipperFormat = val => {
      return `${val.substring(0, 2)}***${val.substring(5, 30)}`;
    };
    const state = reactive({
      columns
    });
    const shipperList = ref([]);
    const driverList = ref([]);
    onMounted(() => {
      shipperList.value = shipperData.map(item => {
        item.phone = phoneFormat(item.phone);
        item.name = shipperFormat(item.name);
        return item;
      });
      driverList.value = driverData.map(item => {
        item.phone = phoneFormat(item.phone);
        item.name = nameFormat(item.name);
        return item;
      });
    });
    const data = computed(() => {
      return activeKey.value === '2' ? shipperList.value : driverList.value;
    });
    return {
      activeKey,
      shipperList,
      driverList,
      data,
      ...toRefs(state),
      dayjs
    };
  }
});